export const blockIconsImageTune = (
	<span className='material-symbols-outlined'>tune</span>
);
